import { ReactNode } from 'react';
import { useTheme } from '../../../contexts/ThemeContext';

interface SettingsSectionProps {
  children: ReactNode;
  title: string;
  description?: string;
}

export default function SettingsSection({ children, title, description }: SettingsSectionProps) {
  const { theme } = useTheme();

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2
            className={`text-xl font-semibold ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}
          >
            {title}
          </h2>
          {description && (
            <p className={`mt-1 text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>
              {description}
            </p>
          )}
        </div>
      </div>
      <div>{children}</div>
    </div>
  );
}
